<template>
  <!-- container start -->
  <div class="container">
    <!-- header start -->
    <header>
      <h1><a href="./"><img src="../assets/site_logo.png" alt="みちのく震録伝" /></a></h1>
      <h2>みちのく震録伝<span class="site-name">自然災害アーカイブβ2.0</span><br>
        <span class="site-copy">東日本大震災に関するあらゆる記憶、記録、事例、知見を収集し、国内外や未来に共有します</span></h2>
      <!--<div class="head-r">
           <a href=""><img src="../assets/btn_rireki_ex.png" alt=""></a>
           </div>-->
    </header>
    <!-- nav start -->
    <nav>
      <div class="search-box">
        <div class="btn-cond"><a href="#" class="drawer-toggle" v-on:click="changeFacet()"><img src="../assets/btn_cond.png" alt="" /></a></div>

        <div class="search-input"><input type="text" v-model="freeword"></div>
        <div class="search-btn-box">
          <a v-on:click="fetch(true)" class="btn-search"><img src="../assets/search.png" alt="" /><span>検 索</span></a>
          <a v-on:click="changeComparemode()" class="btn-cs"><img src="../assets/comp.png" alt="" />比較検索</a>
          <a v-if="!isMap()" v-on:click="recentMode()" class="btn-rireki"><img src="../assets/rireki.png" alt="" /><span>閲覧履歴</span><span v-if="hasRecent" class="ex"></span></a>
        </div>
      </div>
    </nav>
    <!-- nav end -->

    <!-- contents start -->
    <div class="contents">
      <div class="comp-select-box" v-show="comparemode" >
        <ul class="border-b">
          <li class="comp-select-title">比較検索１</li>
          <li><p class="select-wrap-l">
            <select name="" class="select-m" v-model="comparecondition[1]" v-on:change="changecomparecondition(1)">
              <option v-for="key in Object.keys(UIFacetKey)" v-bind:key="key" v-bind:value="key" v-t="{ path: 'UIFacetKey.' + key}"></option>
              <option v-if="false" value="">キーワード</option>
            </select>
          </p>
          </li>
          <li><select name="" class="select-mp" multiple v-model="selectedcompareoption[1]">
            <option v-for="facet in compareoption[1]" v-bind:key="facet.value" v-bind:value="facet">{{ facetOption(facet, 1) }}</option>
            <template v-if="false">
              <option value="松島市">松島市</option>
              <option value="石巻市">石巻市</option>
              <option value="亘理市">亘理市</option>
            </template>
          </select></li>
          <li><input name="" type="button" value="追加 >" v-on:click="addcomparecondition(1)"><br>
            <input name="" type="button" value="< 削除" v-on:click="deletecomparecondition(1)">
          </li>
          <li><select name="" class="select-mp" multiple  v-model="selectedcomparevalue[1]">
            <option v-for="facet in comparevalue[1]" v-bind:key="facet.value" v-bind:value="facet">{{ facetOption(facet, 1) }}</option>
          </select></li>
        </ul>
        <ul>
          <li class="comp-select-title">比較検索２</li>
          <li><p class="select-wrap-l">
            <select name="" class="select-m" v-model="comparecondition[2]" v-on:change="changecomparecondition(2)">
              <option v-for="key in Object.keys(UIFacetKey)" v-bind:key="key" v-bind:value="key" v-t="{ path: 'UIFacetKey.' + key}"></option>
              <option v-if="false" value="">キーワード</option>
            </select></p>
          </li>
          <li><select name="" class="select-mp" multiple v-model="selectedcompareoption[2]">
            <option v-for="facet in compareoption[2]" v-bind:key="facet.value" v-bind:value="facet">{{ facetOption(facet, 2) }}</option>
            <template v-if="false">
              <option value="松島市">松島市</option>
              <option value="石巻市">石巻市</option>
              <option value="亘理市">亘理市</option>
            </template>
          </select></li>
          <li><input name="" type="button" value="追加 >" v-on:click="addcomparecondition(2)"><br>
            <input name="" type="button" value="< 削除" v-on:click="deletecomparecondition(2)">
          </li>
          <li><select name="" class="select-mp" multiple  v-model="selectedcomparevalue[2]">
            <option v-for="facet in comparevalue[2]" v-bind:key="facet.value" v-bind:value="facet">{{ facetOption(facet, 2) }}</option>
          </select></li>
        </ul>
        <div class="btn-view-box"><a href="#" v-on:click="changeComparemode()">キャンセル</a><a v-on:click="fetchComparemode()">表示</a></div>
      </div>

      <!-- side start -->
      <v-navigation-drawer v-model="facet" class="side drawer-nav" mobile-break-point="770" width="220">
        <div >
          <div class="side-close drawer-toggle none"><img src="../assets/side_close.png"></div>

          <div class="side-inner">

            <div class="side-box">

              <h4 class="btn-acc">キーワード</h4>
              <ul class="acc">
                <li v-for="facet in this.facets('keywords')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['subject']" :value="facet.value" v-on:click="addFacetCondition('subject',facet.value);"><a v-on:click="fetchevent()"><span>{{ facet.name }}</span>({{ facet.count }})</a></label></li>
                <template v-if="false">
                  <li><label><input type="checkbox"><a href="#">津波(50)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">いまをつたえ隊(30)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">被災(30)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">ボランティア(30)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">地震(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">津波(50)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">いまをつたえ隊(30)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">被災(30)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">ボランティア(30)</a></label></li>
                </template>
              </ul>
              <h4 class="btn-acc">空間情報</h4>
              <ul class="acc">
                <li v-for="facet in this.facets('spatials')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['place']" :value="facet.value" v-on:click="addFacetCondition('place',facet.value)"><a v-on:click="fetchevent()">{{ facet.name }}({{ facet.count }})</a></label></li>

                <template v-if="false">
                  <li><label><input type="checkbox"><a href="#">仙台市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">石巻市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">気仙沼市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">多賀城市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">東松島市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">仙台市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">石巻市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">気仙沼市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">多賀城市(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">東松島市(20)</a></label></li>
                </template>
              </ul>
              <h4 class="btn-acc">コンテンツ種別</h4>
              <ul class="acc">
                <li v-for="facet in this.facets('materialTypes')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['mediatype']" :value="facet.name" v-on:click="addFacetCondition('mediatype',facet.name); "><a v-on:click="fetchevent()"><span v-t="{ path: 'mediatype.' + facet.name}"></span>({{ facet.count }})</a></label></li>
                <template v-if="false">
                  <li><label><input type="checkbox"><a href="#">写真(20)</a></label></li>
                  <li><label><input type="checkbox"><a href="#">動画(20)</a></label></li>
                </template>
              </ul>
              <h4 class="btn-acc">日付</h4>
              <ul class="acc">
                <li><label><input type="text" placeholder="yyyymmdd" name="from" v-validate="'date_format:yyyyMMdd'" v-model="facetCondition.from" ></label></li><span>{{ errors.first('from') }}</span>
                <li>〜</li>
                <li><label><input type="text" placeholder="yyyymmdd" name="until" v-validate="'date_format:yyyyMMdd'" v-model="facetCondition.until"></label></li><span>{{ errors.first('until') }}</span>
                <li v-for="facet in this.facets('createdDates')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['created']" :value="facet.name" v-on:click="addFacetCondition('created',facet.name)"><a v-on:click="fetchevent();"><span v-t="{ path: 'created.' + facet.name}"></span>({{ facet.count }})</a></label></li>
              </ul>
              <h4 class="btn-acc">作成者</h4>
              <ul class="acc">
                <li v-for="facet in this.facets('creator')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['creator']" :value="facet.value" v-on:click="addFacetCondition('creator',facet.value)"><a v-on:click="fetchevent()">{{ facet.name }}({{ facet.count }})</a></label></li>

              </ul>
              <h4 class="btn-acc">災害情報</h4>
              <ul class="acc">
                <li v-for="facet in this.facets('coverages')" v-bind:key="facet.name"><label><input type="checkbox" v-model="facetCondition['temporal']" :value="facet.name" v-on:click="addFacetCondition('temporal',facet.value)"><a v-on:click="fetchevent()">{{ facet.name }}({{ facet.count }})</a></label></li>
                <template v-if="false">
                  
                  <li><label><input type="checkbox"><a href="#">東日本大震災</a></label></li>
                  <li><label><input type="checkbox"><a href="#">貞観津波</a></label></li>
                </template>
              </ul>
            </div>

          </div>

          <p class="submit"><a v-on:click="fetch()"><img src="../assets/search.png" alt="" /><span>検 索</span></a></p>

        </div>
      </v-navigation-drawer>
      <!-- side end -->

      <!-- article start -->
      <article>
        <div class="select-box">
          <div class="change-box">
            <ul>
              <li><router-link to="/result"><img v-if="isLine()" src="../assets/btn_list_on.png" alt="" /><img v-else src="../assets/btn_list.png" alt="" /></router-link></li>
              <li><router-link to="/result/tile"><img v-if="isTile()" src="../assets/btn_tile_on.png" alt="" /><img v-else src="../assets/btn_tile.png" alt="" /></router-link></li>
              <li v-if="!isRecentMode"><router-link to="/result/map"><img v-if="isMap()" src="../assets/btn_map_on.png" alt="" /><img v-else src="../assets/btn_map.png" alt="" /></router-link></li>
            </ul>
          </div>
          <div class="result-box">
            <span>{{totalResults}}件</span>
            <div class="control-label">表示件数</div>
            <div class="select-wrap">
              <select name="" v-on:change="fetch()" v-model.number="cnt" type="number" id="">
                <option v-bind:value="20">20</option>
                <option v-bind:value="50">50</option>
                <option v-bind:value="100">100</option>
                <option v-bind:value="200">200</option>
              </select>
            </div>
          </div>
        </div>
        <router-view v-on:itemmode="itemmode" v-on:mapmode="mapmode" v-on:nearmode="nearmode"></router-view>


        <div  v-if="ismore()" class="btn-more-box accordion_head"><img src="../assets/arw_d.png" alt="" /><span v-on:click="idx+=cnt; nextpage()">もっと見る</span></div>    </article>
      <!-- article end -->

    </div>
    <!-- contents end -->
  </div>
  <!-- container end -->
</template>
<script>

 export default {
     computed:{
         hasRecent(){
             return this.$store.state.recent.length > 0;
         },
         totalResults(){
             if(!this.$store.state.data.channel) return 0;
             return this.$store.state.data.channel.totalResults;
         },
         isRecentMode(){
             return this.$store.state.recentMode;
         }
     },
     data: function(){
         return {
             viewmode_: 'line', // 'tile', 'map'
             fetchevent_: false,
             facet: true,
             comparemode: false,
             comparecondition: {1:'subject',2:'place'},
             originalcompareoption:{1:[],2:[]},
             compareoption:{1:[],2:[]},
             selectedcompareoption:{1:[],2:[]},
             selectedcomparevalue: {1:[],2:[]},
             comparevalue: {1:[],2:[]},
             freeword: this.$route.query.freeword,
             facetkey:[],
             facetvalue:[],
             idx: 1,
             cnt: 20,
             minlon: 0,
             minlat: 0,
             maxlon: 0,
             maxlat: 0,
             lat: 0,
             lon: 0,
             heatmap: true,
             resolution: 0,
             facetCondition:this.$store.state.facetCondition,

             DBFacetKey: {keywords:'keyword',
                          spatials: 'ndlkn.Resource-dcterms.spatial-rdf.Description-dcterms.identifier_str',
                          materialTypes:'ndlkn.Resource-dcndl.materialType_str',
                          coverages:'ndlkn.Resource-dcterms.coverage_str',
                          creator:'ndlkn.Resource-dcterms.creator-foaf.Agent-foaf.name_text',
                          createdDates:'ndlkn.Resource-dcterms.created_date'},
             UIFacetKey: {subject:'keywords',
                          place:'spatials',
                          creator:'creator',
                          mediatype:'materialTypes',
                          created:'createdDates',
                          temporal: 'coverages'}
             
         }

     },
     created(){
     },
     methods: {
         _totalResults(){
             if(!this.$store.state.data.channel) return 0;
             return this.$store.state.data.channel.totalResults;
         },
         isLine(){
             return this.viewmode_ === 'line';
         },
         isTile(){
             return this.viewmode_ === 'tile';
         },
         isMap(){
             return this.viewmode_ === 'map';
         },

         ismore(){
             if(this.isMap() || this.$store.state.recentMode) return false
             return this._totalResults() >  (this.idx * this.cnt)
         },
         facetOption(facet, index){
             if(this.comparecondition[index] === 'mediatype' || this.comparecondition[index] === 'created'){
                 return this.$i18n.t(this.comparecondition[index] + '.' + facet.name)
             }else{
                 return facet.name;
             }
         },

         gisParamClear(){
             this.lon = null;
             this.lat = null;
             this.minlon = null;
             this.minlat = null;
             this.maxlon = null;
             this.maxlat = null;
             this.resolution = null;
             this.heatmap = false;
         },
         facetParamClear(){
             const self = this
             Object.keys(this.facetCondition).forEach(function (p) {
                 delete self.facetCondition[p]
             })
         },


         // eventの stop や capture がうまく動作しないため、子要素からfetchするフラグを設定するようにした..
         fetchevent(){
             this.fetchevent_ = true;
         },
         recentMode(){
             this.$store.dispatch('recentMode')
         },
         itemmode(mode){
             this.viewmode_ = mode
             this.gisParamClear()
             this.fetch()
         },
         mapmode(extent, resolution){
             this.viewmode_ = 'map'
             this.gisParamClear()
             if(extent){
                 this.minlon = extent[0]
                 this.minlat = extent[1]
                 this.maxlon = extent[2]
                 this.maxlat = extent[3]
                 this.resolution = resolution;
                 this.heatmap = true;
             }
             this.fetch()
         },
         nearmode(coordinate, resolution){
             this.gisParamClear();
             this.lon = coordinate[0]
             this.lat = coordinate[1]
             this.resolution = resolution;
             this.$store.dispatch('nearfetch', this);
         },
         changeComparemode(){
             this.comparemode = !this.comparemode;
             if(this.comparemode){
                 this.changecomparecondition(1)
                 this.changecomparecondition(2)
             }
         },
         changecomparecondition(index){
             const facetkey = this.comparecondition[index];
             const list = this.facets(this.UIFacetKey[facetkey]);
             if(list){
                 this.originalcompareoption[index] = list.slice();
                 this.compareoption[index] = list.slice();
             }else{
                 this.originalcompareoption[index] = [];
                 this.compareoption[index] = [];
             }
             this.comparevalue[index].splice(0,this.comparevalue[index].length);
         },
         addcomparecondition(index){
             this.selectedcompareoption[index].forEach((v) => {
                 this.comparevalue[index].push(v);

                 //候補から削除
                 this.compareoption[index].forEach((item, p) => {
                     if(item === v){
                         this.compareoption[index].splice(p,1);
                     }
                 })
             });
         },
         deletecomparecondition(index){
             this.selectedcomparevalue[index].forEach((v) => {
                 this.compareoption[index].push(v);

                 //候補から削除
                 this.comparevalue[index].forEach((item, p) => {
                     if(item === v){
                         this.comparevalue[index].splice(p,1);
                     }
                 })
             });
             //表示順を維持する処理
             this.compareoption[index] = this.originalcompareoption[index].filter(element =>{
                 return (this.compareoption[index].indexOf(element) >= 0);
             });

         },
         changeFacet(){
             this.facet = !this.facet;
         },
         async fetch(clear){
             this.idx = 1;
             if(clear) this.facetParamClear();
             await this.$store.dispatch('fetch', this)
             if(this.isMap()){
                 await this.$store.dispatch('mapfetch', this)
             }
         },
         _facetcondition(condition, facet){
             if(condition === 'mediatype' || condition === 'created'){
                 return facet.name;
             }else{
                 return facet.value;
             }
         },
         
         fetchComparemode(){
             var id = 1;
             
             this.$store.dispatch('clearCompareData');
             this.gisParamClear();
             for(const v1 of this.comparevalue[1]){
                 for(const v2 of this.comparevalue[2]){
                     this.facetkey = [ this.comparecondition[1], this.comparecondition[2]]
                     this.facetvalue = [this._facetcondition(this.comparecondition[1], v1),
                                        this._facetcondition(this.comparecondition[2], v2)]

                     this.$store.dispatch('addCompareData', {
                         key: id++,
                         key1: this.facetOption(v1, 1),
                         key2: this.facetOption(v2, 2),
                         param: this
                     });
                 }
             }
             this.facetkey = []
             this.facetvalue = []

             this.$router.push({ path: '/result/compare' })
         },

         async nextpage(){
             this.idx += this.cnt;
             await this.$store.dispatch('fetch', this);
         },
         facets(key){
             const name = this.DBFacetKey[key];
             if(!this.$store.state.data.channel) return [];
             return this.$store.state.data.channel.facetField.filter(function(element){
                 return (element.name == name);
             })[0].valueList;
         },
         addFacetCondition(item, value){
             //モデルのバイディングの前に動作するため、自分で制御
             if(!this.facetCondition[item])  {
                 this.facetCondition[item] = [];
             }
             const index = this.facetCondition[item].indexOf(value)
             if(index < 0){
                 this.facetCondition[item].push(value)
             }else{
                 this.facetCondition[item].splice(index,1)
             }
             if(this.fetchevent_){
                 this.fetch();
                 this.fetchevent_ = false;
             }
         }
     }
 }

</script>
<style scoped>
 article {
     /*float:right;
        width:780px;*/
     margin-left: 260px;
 }

 .select-box {
     width: auto;
     margin: 0;
     padding-bottom: 15px;
     
     border-bottom: 3px solid #332C59;
     overflow: hidden;
 }

 .change-box {
     /*margin-top: 10px;
        float: right;
        width: 60px;*/
 }

 .change-box a {
     margin-right: 10px;
     float: left;
 }

 /*.btn-line {
    display: block;
    width: 20px;
    height: 20px;
    background: url(../assets/btn_line.png) no-repeat left bottom;
    }

    .btn-tile {
    display: block;
    width: 20px;
    height: 20px;
    background: url(../assets/btn_tile.png) no-repeat left bottom;
    }*/

 .here,
 .change-box a:hover {
     /*background-position: top;*/
 }

 .side {
     float: left;
     margin: 0;
     padding: 15px;
     width: 220px;
     /*box-shadow: 0 1px 2px 2px rgba(0,0,0,0.05);
        background: url(../assets/side_bg.png) repeat left top;*/
     font-size: 95%;
     border: 1px solid #332C59;
     box-sizing: border-box;
 }

 article {
     /*margin: 0;
        padding: 5px 0 0 0;
        width: 800px;*/

     overflow: hidden;
     /*background-color: #ccc;*/
 }

 footer {
     
 }


 /*---------------------------------
    Header
    ----------------------------------*/


 header h1 {
     float: left;
     margin-top: 5px;
 }

 header h1 a img{
     width: 70px;
     height: auto;
 }

 header h2 {
     float: left;
     line-height: 1.1;
     margin: 0 0 0 10px;
     font-size: 138%;
 }

 header h2 .site-name{
     margin-left: 15px;
 }

 header h2 .site-copy{
     font-size: 55% ;
     font-weight: normal;
 }

 .head-r {
     float: right;
     margin-top: 18px;
 }


 /*
    .header-info {
    float: right;
    }

    .header-info ul li {
    float: left;
    }

    .btn-change{
    float: left;
    overflow: hidden;
    position: relative;
    display: block;
    float: right;
    width: 20px;
    height: 20px;
    padding: 0;
    margin: 0 5px 0 0;
    border: 1px #2C007B solid;
    cursor: pointer;
    text-align: center;
    margin: 3px 0 10px 5px;
    border-radius: 12px;
    font-size: 75%;
    line-height: 2.2;
    color: #2C007B;
    }

    li.btn-change:hover {
    background-color: #2C007B;
    color: #fff;
    }

    .header-tbox {
    float: right;
    margin-right: 5px;
    }

    .header-bbox {
    clear: both;
    }

    .header-bbox ul li.section {
    margin-top: 22px;
    margin-right: 15px;
    }

    a.btn-entry-m {
    width: 154px;
    height: 40px;
    display: block;
    text-indent: 65px;
    color: #fff;
    background: url(../assets/btn_entry_m.png) no-repeat left top;
    line-height: 3.2;
    font-size: 14px;
    }

    a.btn-search-m {
    width: 154px;
    height: 40px;
    display: block;
    text-indent: 65px;
    color: #fff;
    background: url(../assets/btn_search_m.png) no-repeat left top;
    line-height: 3.2;
    font-size: 14px;
    }

    header a:hover {
    background-position: left bottom;
    }*/


 /*---------------------------------
    search-box
    ----------------------------------*/

 .search-box {
     margin: 0 auto;
     width: 85%;
     padding: 15px 0;
     box-sizing: border-box;
     overflow: hidden;
     position: relative;
 }

 .search-input {
     box-sizing: border-box;
     padding-right: 435px;
     width: 100%;
 }

 .search-input input {
     font-size: 16px;
     padding: 0 10px;
     line-height: 40px;
     width: 100%;
     height: 40px;
     border: 1px solid #332C59;
     color: #332C59;
     box-sizing: border-box;
     -webkit-appearance: none;
     border-radius: 0;
     background-color: #fff;
 }

 .search-btn-box {
     margin: 0;
     width: 435px;
     position: absolute;
     right: 0;
     top: 15px;
 }
 .search-btn-box ul li {
     padding-left: 15px;
     border-left: 1px solid #332C59;
 }
 .search-btn-box a {
     width: 130px;
     height: 40px;
     display: block;
     margin-left: 15px;
     float: left;
     padding: 0;
     text-align: center;
     line-height: 38px;
     background-color: #332C59;
     font-size: 105%;
     color: #fff;
     box-sizing: border-box;
     /*letter-spacing: 0.1em;*/
     cursor: pointer;
     font-weight: bold;
 }

 .search-btn-box a.btn-rireki {
     position: relative;
 }
 .search-btn-box a span.ex{
     position: absolute;
     width: 10px;
     height: 10px;
     background-color: red;
     display: block;
     left: 0;
     bottom: 0;
 }

 .search-btn-box a img{
     vertical-align: middle;
     margin-right:5px;
 }

 .btn-cond {
     display: none;
 }


 .btn-cond a{
     width: 40px;
     height: 40px;
     display: block;
     padding: 0;
     text-align: center;
     line-height: 40px;
     background-color: #332C59;
     box-sizing: border-box;
     float: left;
 }

 /*.btn-comp {
    background:url(../assets/btn_comp_s.png) no-repeat left top;
    }*/

 .search-box .det-btn-box {
     float: right;
 }


 /*---------------------------------
    side
    ----------------------------------*/
 /*.side-top {
    margin: 10px 0 0 0;
    background: url(../assets/navi_top_bg.png) no-repeat left top;
    display: block;
    width: 164px;
    height: 10px;
    }

    .side-menu {
    margin: 0;
    padding: 0 0 10px 15px;
    background: url(../assets/navi_bg.png) repeat-y left top;
    width: 149px;
    font-size: 95%;
    }


    .side-bottom {
    margin: 0 0 10px 0;
    background: url(../assets/navi_bottom_bg.png) no-repeat left top;
    display: block;
    width: 164px;
    height: 10px;
    }
  */

 .side ul {
     margin-bottom: 20px;}
 
 .side ul {
     padding-left:18px;
     text-indent:-17px;
 }

 ul.mgnb-none {
     margin-bottom: 0;
 }

 .btn-acc {
     cursor: pointer;
     background: url(../assets/ar_u.png) no-repeat right center;
 }
 .ar-d {
     background: url(../assets/ar_d.png) no-repeat right center;
 }

 .accordion_head {
     cursor: pointer;
 }

 .btn-acc:hover,
 .accordion_head:hover {
     opacity: 0.7;
 }

 .side-title {
     font-weight: bold;
     font-size: 110%;
     border-bottom: 2px solid #332C59;
     color: #332C59;
     margin-bottom: 10px;
     display: none;
 }

 .side-close {
     float: right;
     cursor: pointer;
     margin-right: 15px;
     display: none;
 }

 /*---------------------------------
    main
    ----------------------------------*/

 h1 {
     margin: 0 4px 0 0;
     padding: 0;
     float: left;
 }

 h2 {
     margin: 0;
     padding: 16px 0 0 0;
     float: left;
 }

 h3 {
     margin: 0 0 10px 0;
     width: 100%;
     font-size: 120%;
     font-weight: normal;
     border-bottom: 1px dotted #ccc;
 }

 h4 {
     font-size: 105%;
 }

 h5 {
     font-size: 12px;
     margin:0;
     padding:0;
 }

 article p.text-box {
     margin: 10px;
 }

 div.btn-box2 {
     margin: 7px auto 0 auto;
     padding: 5px;
     width: 328px;
     overflow: hidden;
     text-align: center;
 }

 div.btn-box1 {
     margin: 7px auto 0 auto;
     padding: 5px;
     width: 164px;
     overflow: hidden;
     text-align: center;
 }



 div.btn-box1 a:hover,
 div.btn-box2 a:hover {
     background-position: left bottom;
 }

 .clear {
     clear: both;
 }


 div.text-center {
     width: 100%;
     margin: 10px 0 0 0;
     text-align: center;
 }

 div.text-center span{
     font-size: 170%;
     margin: 0 10px;
 }



 .btn-more-box {
     clear: both;
     width: 100%;
     padding: 5px 0;
     margin: 20px 0;
     background-color: #332C59;
     color: #fff;
     text-align: center;
     font-size: 105%;
     display:block;
     cursor: pointer;
 }

 .btn-more-box img {
     margin-right: 10px;
 }

 .btn-more-box:hover {
     /*background-color: #bbb;*/
 }

 .required {
     color: #C69;
 }





 /*---------------------------------
    list
    ----------------------------------*/

 div.list-head span.number {
     float: right;
     font-size: 90%;
     margin: 3px 3px 1px 3px;
 }

 div.list-head span.select {
     float: right;
 }

 /*---------------------------------
    list-box-short
    ----------------------------------*/

 div.list-box-short {
     height: 190px;
     overflow-y: auto;
     border-top: 1px dotted #FF9900;
     border-bottom: 1px dotted #FF9900;
     clear: both;
 }

 /*---------------------------------
    list-box-mid
    ----------------------------------*/

 div.list-box-mid {
     height: 420px;
     overflow-y: auto;
     border-top: 1px dotted #FF9900;
     border-bottom: 1px dotted #FF9900;
     clear: both;
 }


 /*---------------------------------
    list-box-full
    ----------------------------------*/
 div.list-box-full {
     height: 680px;
     overflow-y: auto;
     border-top: 1px dotted #FF9900;
     border-bottom: 1px dotted #FF9900;
     clear: both;
 }



 /*---------------------------------
    paging-box
    ----------------------------------*/



 /*---------------------------------

    main table

    ----------------------------------*/

 article table {
     clear: left;
     margin: 10px auto;
     padding: 0;
     width: 100%;
     border-collapse: collapse;
     border: none;
     font-size: 100%;
 }

 article table th {
     margin: 0 auto;
     padding: 5px 10px;
     border: 1px solid #eee;
     background-color: #FF9900;
     color: #fff;
     line-height: 1.4;
     font-weight: normal;
     text-align: center;
 }

 article table tr td {
     margin: 0;
     padding: 6px 7px 4px 7px;
     border: 1px solid #eee;
     line-height: 1.4;
 }

 article table tr td a,
 article table tr td a:hover{
     text-decoration: none;
 }

 article table tr td a.btn-s {
     border: 1px solid #FF9900;
     margin: 2px 5px;
     padding: 2px 15px 0 15px;
 }

 article table tr td a.btn-s:hover {
     background-color: #FFCC00;
     color: #fff;
 }



 article section table tr td.text-ss {
     width: 4em;
 }

 article section table tr td.text-s {
     width: 5em;
 }

 article section table tr td.text-m {
     width: 6em;
 }

 article section table tr td.text-l {
     width: 7em;
 }

 article section table tr td.text-ll {
     width: 11em;
 }



 /*---------------------------------
    Form
    ----------------------------------*/

 input,textarea,select, .selectbox{
     color: #444;
     margin: 0;
     margin-right: 5px;
     padding: 5px 10px;
     font-size: 94%;
 }

 .upload-box input {
     font-size: 100%;
     width: 150px;
     padding: 3px;
 }
 /*
    select {
    height: 26px;
    font-size: 120%;
    width: 110px;
    color: #555;
    }*/


 select.select-s {
     font-size: 100%;
     width: 52px;
 }

 input.text-m {
     font-size: 100%;
     width: 130px;
 }

 input.text-l {
     font-size: 100%;
     width: 260px;
 }

 input.text-ll {
     font-size: 100%;
     width: 80%;
 }

 input.text-s {/* 日付 */
     font-size: 100%;
     width: 100px;
 }

 input.text-ss {
     font-size: 100%;
     width: 52px;
 }

 textarea {
     width: 97%;
     height: 120px;
     padding: 3px;
     font-size: 100%;
     font-weight: normal;
     color: #444;
     border: 1px solid #ccc;
 }

 textarea.textarea-inquiry {
     font-size: 100%;
     height: 270px;
     color: #666;
 }

 .side input[type="text"]{
     width: 100%;
     box-sizing: border-box;
     border: 1px solid #332C59;
 }

 p.submit {
     margin-top: 15px;
 }

 p.submit a{
     /*margin: 10px auto 0 auto;
        padding: 4px 10px 2px 10px;
        width: 110px;
        display:block;
        text-align: center;
        background-color: #332C59;
        color: #fff;
        -moz-border-radius:5px;
        -khtml-border-radius:5px;
        -webkit-border-radius:5px;
        border-radius:3px;*/
     font-size: 110%;
     display: block;
     padding: 5px 20px;
     text-align: center;
     background-color: #332C59;
     color: #fff;
     box-sizing: border-box;
     font-weight: bold;
     cursor: pointer;
 }

 p.submit a img {
     vertical-align: middle;
     margin-right: 5px;
 }

 p.submit a:hover {
     opacity: 0.7;
 }

 .result-box {
     float: right;
     /*line-height: 3;*/
     margin-left: 10px;
 }
 
 .result-box span {
     margin-left: 10px;
     line-height: 30px;
 }

 .control-label {
     float: left;
     line-height: 30px;
     margin: 0 15px;
     font-weight: 500;
 }

 .select-wrap {
     float: left;
     position: relative;
     width: 6em;
     margin-top: 0;
 }
 .select-wrap:before {
     z-index: 1;
     position: absolute;
     right: 10px;
     top: 0;
     content: '';
     background: url(../assets/ar_d.png) no-repeat center center;
     height: 32px;
     pointer-events: none;
     width: 15px;
 }

 select{
     outline:none;
     -moz-appearance: none;
     text-indent: 0.01px;
     text-overflow: '';
     background: none transparent;
     vertical-align: middle;
     font-size: inherit;
     color: inherit;
     -webkit-appearance: button;
     -moz-appearance: button;
     appearance: button;
     appearance: none;
     -webkit-appearance: none;
     -moz-appearance: none;
     height: 32px;
     line-height: 26px;
     padding: 0 10px;
     border:1px solid #332C59;
     color: #332C59;
     width:100%;
     border-radius:0;
     background-color: #fff;
 }
 select option{
     background-color: #fff;
     color: #333;
     font-family: "Noto Sans Japanese", sans-serif;
 }
 select::-ms-expand {
     display: none;
 }
 select:-moz-focusring {
     color: transparent;
     text-shadow: 0 0 0 #666;
 }
 .select-wrap.select-primary:before{
     color:#fff;
 }
 .select-wrap.select-primary > select{
     background:#666;
     color:#fff;
     border-color:#666;
 }
 .select-wrap.select-primary > select:-moz-focusring {
     color: transparent;
     text-shadow: 0 0 0 #fff;
 }

 .select-wrap.select-inverse:before{
     color:#fff;
 }
 .select-wrap.select-inverse > select{
     color:#fff;
     border-color: #fff;
 }

 .select-wrap.select-inverse > select:-moz-focusring {
     color: transparent;
     text-shadow: 0 0 0 #fff;
 }



 span a.btn-map-s {
     margin-left: 10px;
     padding: 2px 10px;
     line-height: 1;
     text-align: center;
     border: 1px solid #332C59;
     color: #332C59;
     box-sizing: border-box;
     /*-moz-border-radius:5px;
        -khtml-border-radius:5px;
        -webkit-border-radius:5px;
        border-radius:3px;*/
     font-size: 80%;
     display: inline-block;
     background: url(../assets/map.png) no-repeat 38px center;
     padding-right: 20px;
 }

 span a.btn-map-s:hover {
     opacity: 0.7;
 }



 /*---------------------------------

    tile

    ----------------------------------*/

 .tile-box {
     clear: both;
     margin: 20px -20px 0 0;
 }

 .tile-sbox {
     width: 250px;
     float: left;
     margin: 0 20px 20px 0;
 }

 .thumbnail{
     width: 250px;
     overflow: hidden;
     margin: 0;
     display: block;
 }

 .thumbnail a {
     display: block;
 }

 .thumbnail img{
     width: auto;
     height: 250px;
 }



 /*---------------------------------

    comp-select-box

    ----------------------------------*/

 .comp-select-box {
     width: 100%;
     margin: 0 auto 30px auto;
     padding: 10px 30px;
     border: 1px solid #332C59;
     box-sizing: border-box;
     overflow: hidden;
 }

 .comp-select-box ul {
     margin: 0 auto;
     padding: 10px;
     border-bottom: 1px dotted #332C59;
     overflow: hidden;
 }

 .comp-select-box ul li {
     float: left;
     margin: 0 10px;
 }

 .comp-select-box ul li select{
     width: 180px;
 }


 .comp-select-box ul li input{
     margin-bottom: 5px;
 }

 .select-wrap-l {
     float: left;
     position: relative;
     width: auto;
     margin-top: 0;
     margin-right: 5px;
 }
 .select-wrap-l::before {
     z-index: 1;
     position: absolute;
     right: 10px;
     top: 0;
     content: '';
     background: url(../assets/ar_d.png) no-repeat center center;
     height: 32px;
     pointer-events: none;
     width: 15px;
 }

 .comp-select-title {
     width: 20%;
     font-size: 110%;
     font-weight: bold;
 }

 .btn-view-box {
     height: 34px;
     text-align: right;
     width: 270px;
     float: right;
     margin: 10px auto 0;
     overflow: hidden;
 }

 .btn-view-box a{
     float: left;
     margin-left: 15px;
     display: block;
     padding: 3px 20px;
     text-align: center;
     background-color: #332C59;
     color: #fff;
     box-sizing: border-box;
     width: 120px;
 }

 .select-mp {
     height: 160px;
     padding: 5px 10px;
 }

 /*.cancel {
    width: 130px;
    height: 34px;
    display: block;
    margin-left: 0;
    color: #fff;
    background:url(../assets/btn_cancel_s.png) no-repeat left top;
    text-indent:100%;
    white-space:nowrap;
    overflow:hidden;
    float: left;
    }

    .btn-view-s {
    width: 130px;
    height: 34px;
    display: block;
    margin-left: 10px;
    color: #fff;
    background:url(../assets/btn_view_s.png) no-repeat left top;
    float: left;
    }
  */


 /*---------------------------------

    section

    ----------------------------------*/

 .sec-article {
     margin: 1px auto 12px auto;
     padding: 15px 40px;
     width: 900px;
     border: 1px solid #fff;
     box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);
     background: url(../assets/side_bg.png) repeat left top;
 }

 .section-box{
     margin: 10px 0 ;
     width: 900px;
 }

 .tab-box{
     margin: 15px 0;
 }

 .tab-box li{
     float: left;
 }

 .tab-box li a{
     display: block;
     width: 300px;
     height: 35px;
     text-align: center;
     font-size: 110%;
     padding-top: 10px;
 }


 .section-lbox {
     clear: both;
     float: left;
     width: 740px;
 }

 .section-img-box img{
     border: 1px solid #fff;
     box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);
 }

 .section-info {
     margin-top: 15px;
 }

 .section-info img {
     float: left;
     border: 1px solid #fff;
     box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);
 }

 .section-info ul {
     float: left;
     margin-left: 15px;
 }


 .section-rbox {
     float: right;
     widtt: 122px;
     border: 1px dotted #bbb;
     padding: 10px;
 }


 .section-icon-box ul {
     text-align: center;
     margin: 0 auto;
 }

 .section-icon-box ul li{
     float: left;
     margin: 0 3px;
 }

 .section-text-box {
     clear: both;
     font-size: 85%;
     width: 120px;
     margin: 0;
     padding-top: 10px;
     line-height: 1.3;
 }

 .section-point-box{
     widtt: 122px;
     margin: 0;
     padding: 0;
 }

 .section-point-box ul{
     widtt: 122px;
     margin: 0;
     padding: 0;
 }

 .section-point-box ul li{
     clear: both;
     width: 120px;
     margin-top: 10px;
     border: 1px solid #fff;
     box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);
 }


 /*@media screen and (max-width:1610px) {

    .top-n-info {
    min-height: 150px;
    }

    }*/

 @media screen and (max-width:1460px) {

 }


 /* 1120px (Small Desktop, Netbook) */
 @media screen and (max-width:1350px) {
     header {
         width: 90% ;
     }

     .search-box {
         width: 90% ;
     }

     .contents {
         width: 90% ;
     }

     .line-info-sbox dl dt {
         float: none;
         width: 8em;
     }

     .line-info-sbox dl dd {
         margin-left: 0;
         margin-bottom: 10px;
     }

 }


 @media screen and (max-width:1180px) {
     .comp-select-box ul li.comp-select-title {
         float: none;
         margin-bottom: 5px;
     }

     .line-info-box {
         padding-bottom: 50px;
     }

     .line-info-sbox {
         float: none;
         width: 100%;
         padding-right: 0;
     }

     .line-comment-box {
         float: none;
         width: 100%;
         margin-left: 0;
     }

 }


 /* Bootstrap 990px Breakpoint to 480px */
 @media screen and (max-width:991px) {


     .top-search-box {
         margin: 0 auto;
         width: 500px;
     }

     .top-contents {
         width: 500px;
     }

     .comp-select-box ul li select {
         width: 140px;
     }

 }


 @media screen and (max-width:850px) {

 }


 @media screen and (max-width:770px) {

     header {
         width: 94%;
     }

     a:hover,
     footer a:hover {
         opacity: 1;
     }

     .btn-acc:hover,
     .accordion_head:hover {
         opacity: 1;
     }

     p.submit a:hover {
         opacity: 1;
     }

     span a.btn-map-s:hover {
         opacity: 1;
     }


     .search-input {
         padding-right: 300px;
     }

     .search-btn-box {
         margin: 0;
         width: 300px;
     }

     .search-btn-box a.btn-cs {
         display: none;
     }

     article {
         margin-left: 0;
     }

     .side {
         padding-right: 0;
     }

     .side-inner {
         width: 100%;
         height: 96%;

     }

     .side-close {
         height: 45px;
     }

     .side-box {
         padding-right: 20px;
         padding-bottom: 20px;
         height: 100%;
         width: 100%;
         overflow-y: scroll;
         overflow-x: hidden;
         box-sizing: border-box;
         -webkit-overflow-scrolling: touch;
         transform: translateZ(0);
     }

     .side input[type="text"]{
         font-size: 16px;
         transform: scale(1);
     }

     p.submit {
         position: absolute;
         top: -5px;
         left: 10px;
     }

     p.submit a:hover{
         opacity: 1;
     }

     .search-input {
         padding-left: 55px;
     }

     .btn-cond {
         display: block;
     }

     .side-title {
         display: block;
     }

     .side-close {
         display: block;
     }


     .thumbnail a:hover {
         opacity:1;
     }


     #powerTip {
         display: none !important;
     }

     .det-article {
         margin: 0 auto 20px auto;
         padding: 0;
         width: 100%;
         border: none;
     }

     .title-det{
         font-size: 120%;
         border-bottom: 1px solid #332C59;
         margin-bottom: 15px;
         padding-left: 1em;
         padding-bottom: 3px;
         background: url(../assets/lh_c.png) no-repeat left 8px;
     }


     .det-box{
         margin: 15px 0;
         width: 100%;
     }

     .det-info-tlbox {
         float: none;
         width: 100%;
     }

     .det-img-box {
         width: 100%;
         height: auto;
     }

     .btn-ex-box {
         font-size: 90%;
         margin-bottom: 10px;
     }

     .det-info-trbox {
         margin-left: 0;
     }

     .det-map-box iframe{
         height: 280px;
     }


     .det-info-bbox {
         margin: 20px 0;
         padding: 0;
         border-top: 1px solid #332C59;
     }

     .det-map-api {
         display: block;
         padding-right: 20px;
     }
     .det-map-link,
     .det-map-api {
         font-size: 90%;
         overflow: hidden;
     }

     .det-map-link img,
     .det-map-api img {
         margin-top: -2px;
     }

     /*
        .det-info-btbox {
        overflow: hidden;
        }

        .det-info-bbox a {
        margin-right: 1em;
        display: inline-block;
        }*/

     .det-info-btlbox,
     .det-info-btrbox {
         float: none;
         width: 100%;
     }

     .det-info-btrbox {
         margin-left: 0;
     }
     .det-info-btlbox dl,
     .det-info-btrbox dl,
     .det-info-bbox dl{
         border-bottom: 1px dotted #332C59;
         padding: 10px 0;
     }
     .det-info-btlbox dl dt,
     .det-info-btrbox dl dt,
     .det-info-bbox dl dt{
         float: left;
         width: 8em;
         font-weight: bold;
     }

     .det-info-btlbox dl dd,
     .det-info-btrbox dl dd,
     .det-info-bbox dl dd {
         margin-left: 8em;
     }

     .det-info-bbox dl.di-inqno dt,
     .det-info-bbox dl.di-inqno dd {
         display: block;
         float: none;
         width: 100%;
         margin-left: 0;
     }


 }


 /*  */
 @media screen and (max-width:740px) {

     /*common*/

     header {
         height: 60px;
     }

     header h1 {
         margin-top: 3px;
         padding: 0;
         height: 45px;
         width: auto;
         line-height: 1;
     }

     header h1 a img{
         height: 45px;
         width: auto;
     }

     header h2 {
         margin: 6px 0 0 5px;
         padding: 0;
         font-size: 102%;
     }

     header h2 .site-name{
         margin-top: 2px;
         margin-left: 0;
         display: block;
     }

     header h2 .site-copy{
         display: none;
     }

     .contents {
         padding-top: 12px;
     }

     /*---------------------------------
        search-box
        ----------------------------------*/

     .search-box {
         padding: 10px 0;
         overflow: inherit;
     }

     .search-input {
         box-sizing: border-box;
         padding-right: 40px;
         padding-left: 55px;
         width: 100%;
     }

     .search-btn-box {
         width: 40px;
         top: 10px;
     }

     .search-btn-box a {
         width: 40px;
         text-align: center;
         margin-left: 0;
     }

     .search-btn-box a span{
         display: none;
     }

     .search-btn-box a span.ex{
         display: block;
     }


     .search-btn-box a img{
         margin-right:-3px;
     }

     .search-btn-box a.btn-cs {
         display: none;
     }

     .search-btn-box a.btn-rireki {
         top: -60px;
         position: absolute;
     }





     /*tile*/
     .tile-sbox {
         width: 45%;
         float: left;
         margin: 0 5% 15px 0;
     }

     .thumbnail {
         position: relative;
         width: 100%;
         height: auto;
         background: #EEE;
     }
     .thumbnail::before {
         content:"";
         display: block;
         padding-top: 100%; /* 高さを幅の75%に固定 */
     }
     .thumbnail a {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         display: block;
     }

     .thumbnail a img{
         position: absolute;
         width: 100%;
         height: 100%;
     }


     /*map*/

     .map-box {
         padding: 15px 0 0;
     }

     .map-box iframe{
         height: 400px
     }


     /*top*/

     header.top-header {
         margin: 15px 0;
         height: auto;
     }

     header br {
         display: none;
     }

     header h1.top-logo {
         width: 110px;
         height: 110px;
         margin: 10px auto;
     }

     header h2.top-title {
         margin: 0;
         padding: 0 20px;
         font-size: 130%;
         line-height: 1.4;
     }

     header h2.top-title .site-name{
         display: block;
         margin: 0;
     }

     header h2.top-title span.site-copy{
         font-size: 65%;
         font-weight: normal;
         display: inline-block;
         margin: 10px 30px;
     }

     .top-wrapper {
         margin: 10px 0;
         font-size: 95%;
     }

     .top-contents {
         width: 75%;
         margin: 0 auto;
         text-align: center;
     }

     .top-search-box {
         padding: 10px 0;
         overflow: inherit;
         width: 85%;
     }

     .top-search-input {
         box-sizing: border-box;
         padding-right: 40px;
         padding-left: 0;
         width: 100%;
     }

     .top-search-btn-box {
         width: 40px;
         top: 10px;
     }

     .top-search-btn-box a {
         width: 40px;
         text-align: center;
         margin-left: 0;
     }

     .top-search-btn-box a img{
         margin-right: -3px;
     }

     .top-search-btn-box a span{
         display: none;
     }


     .term-box {
         bottom: 130px;
     }

     body.top {
         margin-bottom: 200px;
     }



     /*Footer*/

     /*footer {
        margin: 50px 0 0;
        padding: 0;
        overflow: hidden;
        width: 100%;
        background:#eee url(../assets/bg.png) repeat left top;
        }
      */
     .foot-box {
         width: 90%;
         padding: 8px 90px 8px 0;
         box-sizing: border-box;
         line-height: 1.5;
         height: 80px;
     }

     .flogo-box {
         margin-top: 5px;
     }

     .flogo-box ul li {
         width: 80px;
         margin-right: 10px;
     }

     .fname {
         font-weight: bold;
         font-size: 75% ;
     }

     .fname span{
         display: block;
     }

     .img-responsive {
         width: 100%;
         height: auto;
     }

     .foot-cbox {
         background-color: #332C59;
         width: 100%;
         margin: 0;
     }

     .copy-box {
         width: 90%;
     }

     .copyright {
         padding: 5px 50px 5px 0;
         font-size: 85%;
         box-sizing: border-box;
         line-height: 1.5;
         float: none;
         width: 100%;
     }

     .copyright span{
         display: block;
     }

     .copyright a {
         vertical-align: bottom;
     }

     .term {
         float: none;
         font-size: 90%;
         display: block;
     }

     .toh {
         position: absolute;
         right: 0;
         bottom: 6px;
         width: 65px;
     }

     .toh a img {
         width: 100% ;
         height: auto;
     }


     #page-top {
         width: 40px;
         height: 40px;
         right: 0;
         bottom: 0;
     }

     #page-top img{
         width: 100%;
         height: 100%;
     }


     /*det*/

     .head-r {
         margin-top: 5px;
         margin-right: 2%;
     }

     .head-r .det-btn-box {

     }

     .det-btn-box a {
         text-align: center;
         margin-left: 0;
         width:40px
     }

     .det-btn-box a span{
         display: none;
     }

     .det-btn-box a img{
         margin-right: -5px;
         margin-top: -4px;
     }

 }


 /* 320px (iPhone) */
 @media screen and (max-width:480px) {
     html,
     body {
         overflow-x: hidden !important;
     }
     a:hover img {
         opacity: 1;
     }
     .sp {
         display: block;
     }
     .sp-hidden {
         display: block;
     }

     .hmenu,
     .is-animation .hmenu {
         margin-right: 0;
     }

     .sp-logo {
         display: block;
     }

     .sp-logo img{
         display: block;
         float: left;
     }


     .logo01,
     .is-animation .logo01 {
         width: 240px;
         height: 55px;
     }


     .hmenu .menu {
         margin-top: 15px;
         transition: .2s;
     }

     /*.top-img-box,
        .top-img {
        height: 460px;
        }

        .top-title {
        width: 80%;
        top: 10%;
        left: 10%;
        height: auto;
        margin-top: inherit;
        margin-left: inherit;
        }

        .top-title p{
        font-size: 18px;
        margin-top:
        }

        .top-title p span{
        font-size: 22px;
        }

        .top-title p.search-title {
        margin-top: 30px;
        font-size: 15px;
        }*/

     .search-text{
         width: 60%;
         font-size: 18px;
     }

     .search-submit{
         width: 40%;
         font-size: 18px;
     }

     .btn-l {
         padding: 15px 30px;
         font-size: 120%;
     }

     .contents-full {
         padding-top: 10px;
     }

     .bm-box {
         padding: 15px 10px;
         line-height: 1.7;
     }

     .bm-box ul li{
         background-position: 3px left;
         padding-left: 20px;
     }


 }
</style>
